<template>
  <Teleport to="body">
  <div :class="modalClass" tabindex="-1" role="dialog" id="seatMapModal">
    <div class="modal-dialog modal-lg" role="document" id="seatMapModalDialog" style="width: 98%">
      <div class="modal-content" :style="borderRadius ? 'border-radius: ' + borderRadius + 'px' : ''">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" :aria-label="_('Close')" v-on:click="close"><span aria-hidden="true">&times;</span></button>
          <h4 class="modal-title">{{ show.resource.name }}</h4>
        </div>
        <div class="modal-body" id="seatMapModalBody">
          <div id="seatMap" style="width: 100%; height: 100%"></div>
        </div>
        <div class="modal-footer" v-if="showButtons">
          <button type="button" class="btn btn-default" data-dismiss="modal" v-on:click="zoom" v-if="calculatedScale < 1">{{ _('Zoom') }}</button>
          <button type="button" class="btn btn-default" data-dismiss="modal" v-on:click="close">{{ _('Cancel') }}</button>
          <button type="button" class="btn btn-success" data-dismiss="modal" v-on:click="select">{{ _('OK') }}</button>
        </div>
      </div>
    </div>
  </div>
  </Teleport>
</template>

<script>

import events from '~/lib/events'
import { mapGetters } from 'vuex'
import Konva from 'konva'

export default {
  props: ['showButtons', 'column', 'seatMap', 'show', 'borderRadius', 'theme'],
  data () {
    return {
      stage: null,
      layers: {},
      shapeLayer: null,
      hoverLayer: null,
      calculatedScale: 1,
      scale: 1,
      seats: {},
      seatJson: '{}',
      reservedSeats: [],
      parsedSeatMap: null,
      seatNumbersHidden: false,
      modalVisible: false,
      lastCenter: null,
      lastDist: 0,
      isDragging: false,
      touchStartTs: null
    }
  },
  mixins: [ events ],
  computed: {
    ...mapGetters(['clientid', 'tabid', 'pos']),
    isTouchEnabled() {
      return ('ontouchstart' in window) ||
           (navigator.maxTouchPoints > 0) ||
           (navigator.msMaxTouchPoints > 0)
    },
    activeTheme () {
      if (this.theme) {
        return this.theme
      }
      return 'light'
    },
    modalClass () {
      return 'modal fade in show ' + this.activeTheme
    },
    myComponentId () {
      return this.column ? this.column.identifier + '-' + this.column.component.id + '-seatmap' : null
    }
  },
  methods: {
    zoom () {
      if (this.scale == 1) {
        this.stage.position({ x: 0, y: 0 })
        this.autoScale()
        this.stage.position({ x: (this.stage.width() - (this.parsedSeatMap.canvas.w * this.scale)) / 2, y: (this.stage.height() - (this.parsedSeatMap.canvas.h * this.scale)) / 2 })
      } else {
        this.stage.position({ x: (this.stage.width() - this.parsedSeatMap.canvas.w) / 2, y: (this.stage.height() - this.parsedSeatMap.canvas.h) / 2 })
        this.scale = 1
        this.stage.scaleX(this.scale)
        this.stage.scaleY(this.scale)
      }
      this.drawLayers()
      this.shapeLayer.draw()
      this.hoverLayer.draw()
    },
    drawLayers () {
      for (var key in this.layers) {
        if (Object.prototype.hasOwnProperty.call(this.layers, key)) {
          this.layers[key].draw()
        }
      }
    },
    batchDrawLayers () {
      for (var key in this.layers) {
        if (Object.prototype.hasOwnProperty.call(this.layers, key)) {
          this.layers[key].batchDraw()
        }
      }
    },
    redraw (newSeatMap) {
      if(this.parsedSeatMap === null) {
        this.parsedSeatMap = JSON.parse(newSeatMap.data)
      }
      this.reservedSeats = JSON.parse(newSeatMap.reservedSeats) || []
      for (var seatId in this.seats) {
        if (Object.prototype.hasOwnProperty.call(this.seats, seatId)) {
          let seat = this.seats[seatId]
          if (this.reservedSeats.indexOf(parseInt(seatId, 10)) !== -1) {
            this.disableSeat(seat, true)
          } else if (seat.disabled) {
            this.enableSeat(seat, true)
          }
        }
      }
      // this.drawLayers()
      // this.shapeLayer.draw()
      // this.hoverLayer.draw()
    },
    initSeatMap () {
      this.selectedSeats = []
      let $this = this
      this.parsedSeatMap = JSON.parse(this.seatMap.data)
      this.reservedSeats = []
      if (this.seatMap.reservedSeats) {
        this.reservedSeats = JSON.parse(this.seatMap.reservedSeats)
      }
      var el = document.getElementById('seatMap')
      var modal = document.getElementById('seatMapModal')
      var dialog = document.getElementById('seatMapModalDialog')
      if (!el || !modal || !dialog) {
        return
      }
      var cw = el.clientWidth
      var ch = modal.clientHeight - dialog.clientHeight - 60 // 60 = 30px top / bottom margins
      var scaleX = cw / this.parsedSeatMap.canvas.w
      var scaleY = ch / this.parsedSeatMap.canvas.h
      this.scale = this.calculatedScale = Math.min(scaleX, scaleY)
      Konva.pixelRatio = 1
      var stage = new Konva.Stage({
        container: 'seatMap',
        width: cw,
        height: ch,
        scaleX: this.scale,
        scaleY: this.scale,
        draggable: this.isTouchEnabled ? false : true
        /*,
        dragBoundFunc: (pos) => {
          let x = pos.x
          let y = pos.y
          if (pos.x > 0) {
            x = 0
          } else if (pos.x < this.stage.width() - this.parsedSeatMap.canvas.w) {
            x = this.stage.width() - this.parsedSeatMap.canvas.w
          }
          if (pos.y > 0) {
            y = 0
          } else if (pos.y < this.stage.height() - this.parsedSeatMap.canvas.h) {
            y = this.stage.height() - this.parsedSeatMap.canvas.h
          }
          return {
            x: x,
            y: y
          }
        }
        */
      })
      this.stage = stage
      this.stage.position({ x: (this.stage.width() - (this.parsedSeatMap.canvas.w * this.scale)) / 2, y: (this.stage.height() - (this.parsedSeatMap.canvas.h * this.scale)) / 2 })
      var addToStage = false
      for (var i = 0; i < this.parsedSeatMap.seats.length; i++) {
        var seat = this.parsedSeatMap.seats[i]
        // Editor "disable" takes the seat out of sale. Hide it in the live map.
        if (seat.disabled) {
          continue
        }
        if (!this.layers[0]) {
          addToStage = true
          var layer = new Konva.Layer({
            x: this.parsedSeatMap.canvas.w / 2,
            y: this.parsedSeatMap.canvas.h / 2,
            offsetX: this.parsedSeatMap.canvas.w / 2,
            offsetY: this.parsedSeatMap.canvas.h / 2
          })
          layer.seatY = seat.y
        } else {
          layer = this.layers[0]
          addToStage = false
        }
        $this.seats[seat.seat] = this.makeSeat(seat, layer)
        if (addToStage) {
          this.layers[0] = layer
          this.stage.add(layer)
        }
      }
      this.shapeLayer = new Konva.Layer({
        x: this.parsedSeatMap.canvas.w / 2,
        y: this.parsedSeatMap.canvas.h / 2,
        offsetX: this.parsedSeatMap.canvas.w / 2,
        offsetY: this.parsedSeatMap.canvas.h / 2,
        listening: false
      })
      this.stage.add(this.shapeLayer)
      for (i = 0; i < this.parsedSeatMap.shapes.length; i++) {
        let shape = this.parsedSeatMap.shapes[i]
        this.makeShape(shape, this.shapeLayer)
      }
      if (Array.isArray(this.parsedSeatMap.labels)) {
        for (i = 0; i < this.parsedSeatMap.labels.length; i++) {
          this.makeLabel(this.parsedSeatMap.labels[i], this.shapeLayer)
        }
      }
      this.hoverLayer = new Konva.Layer({
        x: this.parsedSeatMap.canvas.w / 2,
        y: this.parsedSeatMap.canvas.h / 2,
        offsetX: this.parsedSeatMap.canvas.w / 2,
        offsetY: this.parsedSeatMap.canvas.h / 2
      })
      this.stage.add(this.hoverLayer)
      this.drawLayers()
      this.shapeLayer.draw()
      this.hoverLayer.draw()
      this.stage.on('touchstart', (e) => {
        this.touchStartTs = Date.now()
      })
      this.stage.on('touchmove', (e) => {
        this.isDragging = true
        e.evt.preventDefault()
        var touch1 = e.evt.touches[0]
        var touch2 = e.evt.touches[1]
        if (touch1 && touch2) { // Two-finger drag / pinch zoom
          // if the stage was under Konva's drag&drop
          // we need to stop it, and implement our own pan logic with two pointers
          if (this.stage.isDragging()) {
            this.stage.stopDrag()
          }
          var p1 = {
            x: touch1.clientX,
            y: touch1.clientY,
          }
          var p2 = {
            x: touch2.clientX,
            y: touch2.clientY,
          }
          if (!this.lastCenter) {
            this.lastCenter = this.getCenter(p1, p2)
            return
          }
          var newCenter = this.getCenter(p1, p2)
          var dist = this.getDistance(p1, p2)
          if (!this.lastDist) {
            this.lastDist = dist
          }
          // local coordinates of center point
          var pointTo = {
            x: (newCenter.x - this.stage.x()) / this.stage.scaleX(),
            y: (newCenter.y - this.stage.y()) / this.stage.scaleX(),
          }
          var scale = this.stage.scaleX() * (dist / this.lastDist)
          this.stage.scaleX(scale)
          this.stage.scaleY(scale)
          // calculate new position of the stage
          var dx = newCenter.x - this.lastCenter.x
          var dy = newCenter.y - this.lastCenter.y
          var newPos = {
            x: newCenter.x - pointTo.x * scale + dx,
            y: newCenter.y - pointTo.y * scale + dy,
          }
          this.stage.position(newPos)
          this.lastDist = dist
          this.lastCenter = newCenter
          this.scale = scale
        } else if (touch1) { // One finger drag
          if (this.stage.isDragging()) {
            this.stage.stopDrag()
          }
          var p1 = {
            x: touch1.clientX,
            y: touch1.clientY,
          }
          if (!this.lastCenter) {
            this.lastCenter = p1
            return
          }
          var newCenter = p1
          var pointTo = {
            x: (newCenter.x - this.stage.x()) / this.stage.scaleX(),
            y: (newCenter.y - this.stage.y()) / this.stage.scaleX(),
          }
          var scale = this.stage.scaleX()
          // calculate new position of the stage
          var dx = newCenter.x - this.lastCenter.x
          var dy = newCenter.y - this.lastCenter.y
          var newPos = {
            x: newCenter.x - pointTo.x * scale + dx,
            y: newCenter.y - pointTo.y * scale + dy,
          }
          if (Math.abs(dx) > 0.5 && Math.abs(dy) > 0.5) {
            this.stage.position(newPos)
          } 
          this.lastCenter = p1
        }
      })
      this.stage.on('touchend', (e) => {
        const now = Date.now()
        this.lastDist = 0
        this.lastCenter = null
        if (now - this.touchStartTs < 300) {
          this.isDragging = false
        } else {
          setTimeout(() => {
            this.isDragging = false
          }, 100)
        }
      })
      window.onresize = () => {
        this.autoScale()
        if (this.stage) {
          this.stage.position({ x: (this.stage.width() - (this.parsedSeatMap.canvas.w * this.scale)) / 2, y: (this.stage.height() - (this.parsedSeatMap.canvas.h * this.scale)) / 2 })
        }
        this.batchDrawLayers()
        if (this.shapeLayer) {
          this.shapeLayer.draw()
        }
        if (this.hoverLayer) {
          this.hoverLayer.draw()
        }
      }
    },
    getDistance(p1, p2) {
      return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2))
    },
    getCenter(p1, p2) {
      return {
        x: (p1.x + p2.x) / 2,
        y: (p1.y + p2.y) / 2,
      }
    },
    getSeatFillColor (seat) {
      switch (this.theme) {
        case 'dark':
          switch (seat.bg) {
            case 'blue':
              return '#B3C3CB'
            case 'purple':
              return '#D1C8E4'
            case 'yellow':
              return '#D8DBCC'
            case 'green':
              return '#C0E0CD'
            default:
              return '#999999'
          }
        case 'light':
        default:
          switch (seat.bg) {
            case 'blue':
              return '#CDEEFE'
            case 'purple':
              return '#F0CDFE'
            case 'yellow':
              return '#FEF4CD'
            case 'green':
              return '#CEFDCF'
            default:
              return 'white'
          }
      }
    },
    getSeatSelectedColor () {
      return '#22dd44'
    },
    getSeatDeactivatedColor () {
      switch (this.theme) {
        case 'dark':
          return '#ff4c4c'
        case 'light':
        default:
          return '#ff4c4c'
      }
    },
    getSeatStrokeColor () {
      switch (this.theme) {
        case 'dark':
          return '#666666'
        case 'light':
        default:
          return '#999999'
      }
    },
    makeSeat (seat, layer) {
      let $this = this
      var sw = seat.w
      var sh = seat.h
      var s = new Konva.Rect({
        x: 0,
        y: 0,
        cornerRadius: seat.r,
        width: sw,
        height: sh,
        fill: this.getSeatFillColor(seat),
        stroke: this.getSeatStrokeColor(),
        strokeWidth: 2,
        perfectDrawEnabled: false
      })
      var h = new Konva.Text({
        x: 0,
        y: 3,
        width: sw,
        height: sh,
        text: seat.header,
        fontSize: 10,
        fontFamily: 'Oxygen, sans-serif',
        align: 'center',
        listening: false
      })
      var t = new Konva.Text({
        x: 0,
        y: 15,
        width: sw,
        height: sh,
        text: seat.title,
        fontSize: 15,
        fontFamily: 'Oxygen, sans-serif',
        fontStyle: 'bold',
        align: 'center',
        listening: false
      })
      var g = new Konva.Group({
        x: seat.x + 2 + sw / 2,
        y: seat.y + 2 + sh / 2,
        offsetX: sw / 2,
        offsetY: sh / 2
      })
      g.add(s)
      g.add(h)
      g.add(t)
      layer.add(g)
      if (this.reservedSeats.indexOf(seat.seat) !== -1) {
        s.fill(this.getSeatDeactivatedColor())
        // g.opacity(0.5)
        g.disabled = true
      }
      g.seatId = seat.seat
      g.linkedSeats = seat.linkedSeats
      g.bg = seat.bg
      // s.cache()
      g.on('click', (function (seat) {
        return function () {
          if (!seat.disabled) {
            $this.toggleSeat(seat)
            seat.draw()
          }
        }
      })(g))
      g.on('mouseover', (function (seat) {
        return function () {
          if (!seat.disabled) {
            seat.moveTo($this.hoverLayer)
            seat.scale({ x: 1.05, y: 1.05 })
            $this.hoverLayer.draw()
          }
        }
      })(g))
      g.on('mouseout', (function (seat) {
        return function () {
          if (!seat.disabled) {
            seat.moveTo($this.layers[0])
            seat.scale({ x: 1, y: 1 })
            seat.draw()
            $this.hoverLayer.draw()
          }
        }
      })(g))
      g.on('tap', (function (seat) {
        return function () {
          if (!seat.disabled && !$this.isDragging) {
            $this.toggleSeat(seat)
            seat.draw()
          }
        }
      })(g))
      g.getChildren().forEach(function (shape) {
        shape.hitStrokeWidth(0)
        shape.shadowForStrokeEnabled(false)
      })
      return g
    },
    makeShape (shape, layer) {
      switch (shape.type) {
        case 'rect':
        case 'rrect':
          return this.makeRRect(shape, layer)
        case 'line':
          return this.makeLine(shape, layer)
      }
    },
    makeLine (shape, layer) {
      if (!Array.isArray(shape.points) || shape.points.length < 4) {
        return
      }
      var line = new Konva.Line({
        points: shape.points,
        stroke: shape.stroke || '#334155',
        strokeWidth: shape.strokeWidth != null ? shape.strokeWidth : 6,
        lineCap: shape.lineCap || 'round',
        lineJoin: shape.lineJoin || 'round',
        listening: false
      })
      layer.add(line)
      return line
    },
    makeLabel (label, layer) {
      var text = new Konva.Text({
        x: label.x,
        y: label.y,
        text: label.text || '',
        fontSize: label.fontSize != null ? label.fontSize : 16,
        fontFamily: label.fontFamily || 'Segoe UI',
        fill: label.fill || '#0284c7',
        align: 'left',
        verticalAlign: 'top',
        listening: false
      })
      layer.add(text)
      return text
    },
    makeRRect (shape, layer) {
      var s = new Konva.Rect({
        x: 0,
        y: 0,
        cornerRadius: shape.type == 'rect' ? 0 : shape.r,
        width: shape.w,
        height: shape.h,
        fill: shape.fill,
        stroke: shape.border ? shape.border : null,
        strokeWidth: shape.border ? 2 : 0
      })
      let shapeText = ''
      if (shape.text) {
        shapeText = shape.text
      } else if (!shape.subtype || shape.subtype === 'screen') {
        shapeText = this._('Screen').toUpperCase()
      }
      var t = new Konva.Text({
        x: 0,
        y: 0,
        width: shape.w,
        height: shape.h,
        text: shapeText,
        verticalAlign: 'middle',
        letterSpacing: 1,
        fontSize: 10,
        fontStyle: 'bold',
        fontFamily: 'Oxygen, sans-serif',
        align: 'center',
        listening: false
      })
      var g = new Konva.Group({
        x: shape.x,
        y: shape.y,
        offsetX: 0,
        offsetY: 0
      })
      g.add(s)
      g.add(t)
      layer.add(g)
      return g
    },
    autoScale () {
      let el = document.getElementById('seatMap')
      if (el) {
        var modal = document.getElementById('seatMapModal')
        var dialog = document.getElementById('seatMapModalDialog')
        var body = document.getElementById('seatMapModalBody')
        var cw = el.clientWidth
        var ch = modal.clientHeight - dialog.clientHeight + (body.clientHeight - 30) - 60 // 60 = 30px top / bottom margins, 30 = 15px top / bottom margins for body
        var scaleX = cw / this.parsedSeatMap.canvas.w
        var scaleY = ch / this.parsedSeatMap.canvas.h
        this.scale = this.calculatedScale = Math.min(scaleX, scaleY)
        this.stage.width(cw)
        this.stage.height(ch)
        this.stage.scaleX(this.scale)
        this.stage.scaleY(this.scale)
      }
    },
    drawSeatLayer (seat) {
      this.layers[0].draw()
      this.hoverLayer.draw()
      /*
      for (var key in this.layers) {
        if (Object.prototype.hasOwnProperty.call(this.layers, key)) {
          let layer = this.layers[key]
          if (true || Math.abs(layer.seatY - seat.y()) < 40) {
            layer.draw()
          }
        }
      }
      */
    },
    disableSeat (seat) {
      var rects = seat.getChildren(function (node) {
        return node.getClassName() === 'Rect'
      })
      if (rects) {
        for (var i = 0; i < rects.length; i++) {
          seat.selected = false
          rects[i].fill(this.getSeatDeactivatedColor())
          rects[i].stroke(this.getSeatStrokeColor())
          seat.opacity(0.5)
          seat.disabled = true
          this.$emit('seatDeselected', seat.seatId)
        }
      }
      seat.scale({ x: 1, y: 1 })
      seat.draw()
      // this.drawSeatLayer(seat)
    },
    enableSeat (seat) {
      var rects = seat.getChildren(function (node) {
        return node.getClassName() === 'Rect'
      })
      if (rects) {
        for (var i = 0; i < rects.length; i++) {
          seat.selected = false
          rects[i].fill(this.getSeatFillColor(seat))
          rects[i].stroke(this.getSeatStrokeColor())
          seat.opacity(1)
          seat.disabled = false
          this.$emit('seatDeselected', seat.seatId)
        }
      }
      seat.scale({ x: 1, y: 1 })
      seat.draw()
      // this.drawSeatLayer(seat)
    },
    toggleSeat (seat, propagated, linked) {
      var rects = seat.getChildren(function (node) {
        return node.getClassName() === 'Rect'
      })
      if (rects) {
        for (var i = 0; i < rects.length; i++) {
          if (!seat.selected) {
            seat.selected = true
            rects[i].fill(this.getSeatSelectedColor())
            rects[i].stroke(this.getSeatStrokeColor())
            this.$emit('seatSelected', seat.seatId)
            if (!propagated) {
              this.$socket.emit('message', {
                type: 'seatSelected',
                data: seat.seatId,
                shopId: this.$store.state.shopId,
                pos: this.pos,
                clientid: this.clientid,
                tabid: this.tabid,
                show: this.show.id
              })
            }
          } else {
            seat.selected = false
            rects[i].fill(this.getSeatFillColor(seat))
            rects[i].stroke(this.getSeatStrokeColor())
            this.$emit('seatDeselected', seat.seatId)
            if (!propagated) {
              this.$socket.emit('message', {
                type: 'seatDeselected',
                data: seat.seatId,
                shopId: this.$store.state.shopId,
                pos: this.pos,
                clientid: this.clientid,
                tabid: this.tabid,
                show: this.show.id
              })
            }
          }
        }
      }
      seat.scale({ x: 1, y: 1 })
      seat.draw()
      if (!linked && !propagated && seat.linkedSeats) {
        for (let i = 0; i < seat.linkedSeats.length; i++) {
          let ls = this.seats[seat.linkedSeats[i]]
          if (ls) {
            this.toggleSeat(ls, false, true)
          }
        }
      }
      // this.drawSeatLayer(seat)
    },
    hideSeatNumbers () {
      this.seatNumbersHidden = true
      for (var seatId in this.seats) {
        if (Object.prototype.hasOwnProperty.call(this.seats, seatId)) {
          let seat = this.seats[seatId]
          var rects = seat.getChildren(function (node) {
            return node.getClassName() === 'Text'
          })
          if (rects) {
            for (var i = 0; i < rects.length; i++) {
              rects[i].opacity(0)
            }
          }
        }
      }
    },
    showSeatNumbers () {
      this.seatNumbersHidden = false
      for (var seatId in this.seats) {
        if (Object.prototype.hasOwnProperty.call(this.seats, seatId)) {
          let seat = this.seats[seatId]
          var rects = seat.getChildren(function (node) {
            return node.getClassName() === 'Text'
          })
          if (rects) {
            for (var i = 0; i < rects.length; i++) {
              rects[i].opacity(1)
            }
          }
        }
      }
    },
    destroySeatMap () {
      for (var key in this.layers) {
        if (Object.prototype.hasOwnProperty.call(this.layers, key)) {
          this.layers[key].setSize(0, 0)
          this.layers[key].destroy()
        }
      }
      if (this.shapeLayer) {
        this.shapeLayer.setSize(0, 0)
        this.shapeLayer.destroy()
      }
      if (this.hoverLayer) {
        this.hoverLayer.setSize(0, 0)
        this.hoverLayer.destroy()
      }
      if (this.stage) {
        this.stage.destroy()
      }
      this.stage = null
      this.layers = {}
      this.shapeLayer = null
      this.hoverLayer = null
      this.seats = {}
      this.seatJson = '{}'
      this.reservedSeats = []
      this.parsedSeatMap = null
    },
    close () {
      this.$emit('closeModal')
    },
    select () {
      this.$emit('confirmSelection', this.show)
    }
  },
  watch: {
    scale (newScale, oldScale) {
      if (newScale == oldScale) {
        return
      }
      if (!this.isTouchEnabled) {
        if (newScale == 1) {
          this.stage.draggable(true)
        } else {
          this.stage.draggable(false)
        }
      }
      let hideAt = 0.5
      if (newScale <= hideAt && !this.seatNumbersHidden) {
        this.hideSeatNumbers()
      } else if (newScale > hideAt && this.seatNumbersHidden) {
        this.showSeatNumbers()
      } else {
        return
      }
      this.batchDrawLayers()
      this.shapeLayer.draw()
      this.hoverLayer.draw()
    }
  },
  mounted () {
    this.initSeatMap()
    if(!this.events) {
      let events = {}
      events['seatSelected'] = (message) => {
        if (message.clientid == this.clientid && message.tabid == this.tabid) {
          return
        }
        if (message.shopId != this.$store.state.shopId) {
          return
        }
        if (message.show != this.show.id) {
          return
        }
        let seat = this.seats[message.data]
        if (seat) {
          if (message.pos == this.pos) {
            this.toggleSeat(seat, true)
          } else {
            this.disableSeat(seat)
          }
        }
      }
      events['seatDeselected'] = (message) => {
        if (message.clientid == this.clientid && message.tabid == this.tabid) {
          return
        }
        if (message.shopId != this.$store.state.shopId) {
          return
        }
        if (message.show != this.show.id) {
          return
        }
        let seat = this.seats[message.data]
        if (seat) {
          if (message.pos == this.pos) {
            this.enableSeat(seat)
          } else {
            this.disableSeat(seat)
          }
        }
      }
      this.events = events
    }
    this.enableEventBus()
  },
  beforeUnmount () {
    this.destroySeatMap()
    window.onresize = null
  }
}
</script>

<style scoped>
.dark .modal-content {
  border-color: #111111;
  background-color: #222222;
}
.dark .modal-title {
  color: #98ADB8;
}
.dark .modal-header {
  border-bottom-color: #111111;
}
.dark .close {
  color: #ffffff;
}
</style>